import { cn } from "utils";
import { useEffect, useState } from "react";
import NextImage from "../NextImage";
import { formatPriceChange } from "@/src/utils";
import { ROUTER_PATH } from "@/src/config";
import { useRedirectChat, useShellRouter } from "@/src/hooks";

type TokenCardProps = {
  token: string;
  icon: string;
  price?: string;
  id?: string;
};

export const TokenCard: React.FC<Partial<TokenCardProps>> = ({
  token,
  price,
  icon,
  id,
}) => {
  const router = useShellRouter();
  const { handleCheckChatVaild } = useRedirectChat();
  const [isLoading, setIsLoading] = useState(false);
  const handleClick = () => {
    if (isLoading) {
      return;
    }
    if (id) {
      setIsLoading(true);
      router.push(`${ROUTER_PATH.CRYPTO_TOKEN}/${id}`);
      return;
    }
    handleCheckChatVaild({
      question: token || "",
      sign: "token_introduction",
    });
  };

  useEffect(() => {
    if (isLoading) {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 3000);
      return () => {
        setIsLoading(false);
        clearTimeout(timer);
      };
    }
  }, [isLoading]);

  const { formattedValue, finalShowZero, isEmpty, priceChange } =
    formatPriceChange(price);
  return (
    <div className="w-[232px] flex items-center">
      <div
        data-openreplay-label="TokenCarousel · TokenCard · div"
        className={cn(
          "flex items-center h-9 w-[200px] py-2 rounded-[9px] gap-2 cursor-pointer",
          isLoading && "opacity-50 cursor-progress",
        )}
        onClick={handleClick}
      >
        <NextImage
          src={icon}
          alt="icon"
          width={20}
          height={20}
          className="rounded-full"
        />
        <div className="flex justify-between flex-1 items-center">
          <div className="text-content_primary body_medium_m">{token}</div>
          {isEmpty ? (
            <div className="body_medium_m text-content_tertiary">--</div>
          ) : (
            <div
              className={cn("body_medium_m", {
                "text-content_accent1_primary": priceChange >= 0,
                "text-content_accent2_primary": priceChange < 0,
                "text-content_tertiary": finalShowZero,
              })}
            >
              {finalShowZero ? "0.0%" : formattedValue}
            </div>
          )}
        </div>
      </div>
      <div className="h-[22px] bg-background_white_overlay10 w-[1px] mx-4" />
    </div>
  );
};
